import sprite from './sprite.js'; //Генератор svg спрайта
import Media from './mediaDetect.js'; //Детектор медиа

import Captcha from './components/captcha.js';
import Tabs from './components/tabs.js';
import Switcher from './components/switcher.js';
import Nav from './components/nav.js';
import Pulpmill from './components/pulpmill.js';
import Search from './components/search.js';
import ArrowToTop from './components/js-to-top.js';
import jsAccordion from './components/js-accordion.js';
import PageAbout from './components/page-about.js';
import jsHistory from './components/history.js';
//import Team from './components/team.js';
import Popup from './components/popup.js';
import jsShowHide from './components/js-show-hide.js';
import Map from './components/map.js';
import Resume from './components/resume.js';
import AskQuestions from './components/ask-question.js';
import Fsc from './components/fsc.js';
import CorpResp from './components/corporate-responsibility.js';
import PressCenter from './components/press-center.js';
import Advantages from './components/advantages.js';
import Main from './components/main.js';
import Lang from './components/lang-message.js';

$(document).ready(function($) {

    $.extend($.validator.messages, {
        required: Lang.message.empty_field,
        email: Lang.message.invalid_email_field
    });

    let stylizedPlaceholderWrap = $('[data-stylized-placeholder-wrap]');
    if(stylizedPlaceholderWrap.length) {

        let inputPlaceholder = stylizedPlaceholderWrap.find('input');

        inputPlaceholder.each(function(index) {
          var _this = $(this);

          if(_this.val() != '')
            _this.closest('[data-stylized-placeholder-wrap]').find('[data-stylized-placeholder]').hide();
        });

        inputPlaceholder
          .on('focus', function(){
            $(this).closest('[data-stylized-placeholder-wrap]').find('[data-stylized-placeholder]').hide();
          })
          .on('blur', function(){
            if ($(this).val().trim() === '') {
              $(this).closest('[data-stylized-placeholder-wrap]').find('[data-stylized-placeholder]').show();
            }
          });
    }

    let formPopup = $('[data-form-popup]');
    if (formPopup.length) {
        $('[data-close-form-popup]').on('click', function(){
            $(this).closest('[data-form-popup]').removeClass('open');
            $('body').removeClass('open-form-popup');
        });
    }

    setPositionObjAnchor();
    $(window).resize(function(){
        setPositionObjAnchor();
    });

    function setPositionObjAnchor(){

      let objAnchor = $('[data-obj-anchor]');
      if(objAnchor.length) {

        var headerHeight = $('[data-header]').outerHeight(),
            delta = headerHeight + 30; //30px - отступ сверху, чтобы не прилипало к заголовку

        if(Media.detect().isDesktop){
            objAnchor.css('margin-top', '-' + delta + 'px');
        }else {
            objAnchor.removeAttr('style');
        }
      }
    }

    $('table').wrap('<div class="table-wrap" data-wrap-table-scroll="true"></div>');

    $('[data-wrap-table-scroll]').each(function() {
        var _this = $(this);

        _this.scrollbar({
            onScroll: function(y, x){

                var scrollWrap = _this.closest('.scroll-wrapper');

                if(parseInt(x.scroll) > 0){
                    scrollWrap.addClass('start');
                } else {
                    scrollWrap.removeClass('start');
                }

                if(parseInt(x.scroll) == parseInt(x.maxScroll)){
                    scrollWrap.addClass('finish');
                } else {
                    scrollWrap.removeClass('finish');
                }

                if(parseInt(x.maxScroll) > 0){
                    scrollWrap.addClass('scrollx_visible');

                    if (!scrollWrap.find('.shadow').length){
                        scrollWrap.append('<div class="shadow shadow_body shadow_left"></div>');
                        scrollWrap.append('<div class="shadow shadow_body shadow_right"></div>');
                    }
                } else {
                    scrollWrap.removeClass('scrollx_visible');
                }
            }
        });
    });

        
});



// WEBPACK FOOTER //
// ./index.js